export const newCadenceSteps = [
    {
        step: 1,
        label: "Grupy i Kontakty",
        tooltip: "Obecne grupy oraz kontakty",
        routeName: "NewCadenceWizardsSteps"
    },
    //{
    //    step: 2,
    //    label: "Transmisja",
    //    tooltip: "Ustawienia tranmisji, kamer oraz mikrofonów",
    //    routeName: "NewCadenceWizardsSteps"
    //},
    {
        step: 3,
        label: "Administratorzy",
        tooltip: "Administratorzy, którzy mają zostać przniesieni",
        routeName: "NewCadenceWizardsSteps",
    },
    {
        step: 4,
        label: "Szablony",
        tooltip: "Szablony posiedzeń",
        routeName: "NewCadenceWizardsSteps",
    },
    {
        step: 5,
        label: "Radni",
        tooltip: "Konta użytkowników w systemie",
        routeName: "NewCadenceWizardsSteps",
    },
    {
        step: 6,
        label: "Podsumowanie",
        tooltip: "Podsumowanie",
        routeName: "NewCadenceWizardsSteps",
    }
]